import * as React from "react"
import { Link } from "gatsby"
import cx from "classnames"

export default function Button({
  text,
  link,
  color = "blue",
  type = "default",
  hover = "white",
}) {
  return (
    <>
      {link.startsWith("http://") || link.startsWith("https://") ? (
        <a href={link} target="_blank" className="mt-0">
          <span
            className={cx(
              "transition inline-flex font-montserrat block",
              color === "white" && "bg-white text-black",
              color === "blue" && "bg-pfb-blue text-white hover:bg-pfb-navy",
              color === "navy" && "bg-pfb-navy text-white hover:bg-pfb-blue",
              color === "green" &&
                "bg-gossamer text-white hover:bg-gossamer-dark",
              color === "gray" && "bg-gray-100 text-black",
              color === "yellow" && "bg-pfb-yellow text-white",
              type === "tab" && "font-dharma font-light text-3xl py-3 px-4",
              type === "small" && "font-bold uppercase text-base py-2 px-5",
              type === "default" &&
                "font-bold uppercase text-base lg:text-lg py-2 lg:py-3 px-4",
              hover === "white" && "hover:bg-white hover:text-pfb-navy",
              hover === "blue" && "hover:bg-pfb-blue hover:text-white",
              hover === "navy" && "hover:bg-pfb-navy hover:text-white",
              hover === "gray" && "hover:bg-gray-200 hover:text-black"
            )}
          >
            {text}
          </span>
        </a>
      ) : (
        <Link
          to={link}
          target={
            link.startsWith("http://") || link.startsWith("https://")
              ? "_target"
              : ""
          }
        >
          <span
            className={cx(
              "transition inline-flex font-montserrat",
              color === "white" && "bg-white text-black",
              color === "blue" && "bg-pfb-blue text-white hover:bg-pfb-navy",
              color === "navy" && "bg-pfb-navy text-white hover:bg-pfb-blue",
              color === "green" &&
                "bg-gossamer text-white hover:bg-gossamer-dark",
              color === "gray" && "bg-gray-100 text-black",
              type === "tab" && "font-dharma font-light text-3xl py-3 px-4",
              type === "small" && "font-bold uppercase text-base py-2 px-5",
              type === "default" &&
                "font-bold uppercase text-base lg:text-lg py-2 lg:py-3 px-4",
              hover === "white" && "hover:bg-white hover:text-pfb-navy",
              hover === "blue" && "hover:bg-pfb-blue hover:text-white",
              hover === "navy" && "hover:bg-pfb-navy hover:text-white",
              hover === "gray" && "hover:bg-gray-200 hover:text-black"
            )}
          >
            {text}
          </span>
        </Link>
      )}
    </>
  )
}
